import script from "./PaActionBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaActionBar.vue?vue&type=script&setup=true&lang=ts"

import "./PaActionBar.vue?vue&type=style&index=0&id=27213b7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27213b7a"]])

export default __exports__